module.exports = __webpack_public_path__ + "media/images/ShareWhite-dd1d5585d04035bac4406ee185b740ef.svg";